import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_projects/projects/$projectId')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: 'projectId',
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
